import { ChevronDown, FileText, LogOut, UserPen } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import { AUTH_PATHS, PROFILE_PATH } from "../../constants";
import { useAuth } from "../../contexts/AuthContext";
import { canViewOwnPreference } from "../../permissions/preferences";
import { useNavigateToCustomizeReport } from "../../utils";

const UserMenu = () => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const userMenuRef = useRef<HTMLDivElement>(null);
  const { signOut, user, firmContext } = useAuth();
  const navigate = useNavigate();
  const goToCustomizeReport = useNavigateToCustomizeReport();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
        setShowUserMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleUserMenuClick = () => {
    setShowUserMenu((prev) => !prev);
  };

  return (
    <div className="user-menu" ref={userMenuRef}>
      <button
        type="button"
        data-testid="user-menu-trigger"
        className={`user-menu-trigger ${showUserMenu ? "active" : ""}`}
        onClick={handleUserMenuClick}
      >
        <div className="user-avatar">{user?.email ? user.email[0].toUpperCase() : "U"}</div>
        <ChevronDown size={16} className={`trigger-chevron ${showUserMenu ? "rotated" : ""}`} />
      </button>

      {showUserMenu && (
        <div className="user-menu-dropdown">
          <button
            type="button"
            className="user-menu-item"
            onClick={() => {
              setShowUserMenu(false);
              navigate(PROFILE_PATH);
            }}
          >
            <UserPen size={18} />
            <span>Profile</span>
          </button>

          {canViewOwnPreference(firmContext) && (
            <button
              type="button"
              className="user-menu-item"
              onClick={() => {
                setShowUserMenu(false);
                void goToCustomizeReport();
              }}
            >
              <FileText size={18} />
              <span>Customize report</span>
            </button>
          )}

          <button
            type="button"
            className="user-menu-item"
            onClick={() => {
              signOut()
                .then(() => {
                  toast.success("Logged out successfully");
                  navigate(AUTH_PATHS.SIGNIN);
                })
                .catch(() => {
                  toast.error("Failed to log out");
                  setShowUserMenu(false);
                });
            }}
          >
            <LogOut size={18} />
            <span>Logout</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
